<template>
  <div v-if="params.colDef.CellRendererParams.fromModule === 'admin' && params.colDef.CellRendererParams.checkPaymentApproval === true">
    <!-- {{data[indextr].approved}} -->
    <vs-tooltip
      color="primary"
      text="Share the payslip"
      v-if="params.data.approved === 0"
    >
      <span
        class="material-icons share-rotate"
        @click="params.colDef.CellRendererParams.SharingPaySlip(params.data, params.rowIndex)"
        >reply</span
      >
    </vs-tooltip>
    <vs-tooltip color="#28c870" text="Pay Slip is shared" v-else>
      <span class="material-icons-outlined pay_shared">task_alt</span>
    </vs-tooltip>
  </div>
</template>

<script>
export default {
  name: 'ShareCell'
}
</script>